// CANONICAL COPY (GH #7115). src/constants/obligations/obl-vulnerability-scan-programme.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-vulnerability-scan-programme',
  title: 'Perform quarterly internal and external vulnerability scans',
  description:
    'Execute the formal vulnerability scanning programme: internal vulnerability scans at least quarterly and after any significant change; external vulnerability scans at least quarterly by a qualified scanning vendor. All high-risk and critical vulnerabilities shall be addressed and rescanned to confirm resolution. Retain scan reports, remediation tickets and rescan evidence. This is distinct from general vulnerability management (which also covers threat intelligence, exposure evaluation and routine patching cadence) — the programme enforces the formal quarterly cadence, qualified-vendor requirement, and rescan-to-close discipline required by PCI DSS v4.0 Req 11.',
  category: 'technical',
  scfIds: ['SCF-AUD-004'],
  cadence: { frequency: '3m', anchor: 'domain' },
  strategy: 'manual',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Vulnerability scanning programme or latest scan report is published',
    },
    { type: 'document-within-sla', description: 'Quarterly scan is not overdue' },
    {
      type: 'manual-attestation',
      description: 'Confirm the quarterly internal and external scans were actually run',
    },
  ],
  domainActions: [{ type: 'upload-artefact', label: 'Upload Evidence' }],
};
